export default {
	retourbouton: 'Retour à la liste des enfants',
	periodeEnCours: 'Revenir à l\'âge actuel',
	periodes : [
		{
			label : 'Naissance à 1 mois',
			moisAffichage: '1',
			moisMax : 2
		},
		{
			label : '2 mois',
			moisAffichage: '2',
			moisMax : 3
		},
		{
			label : '3 mois',
			moisAffichage: '3',
			moisMax : 4
		},
		{
			label : '4 mois',
			moisAffichage: '4',
			moisMax : 5
		},
		{
			label : '5 et 6 mois',
			moisAffichage: '6',
			moisMax : 7
		},
		{
			label : '7 et 8 mois',
			moisAffichage: '8',
			moisMax : 9
		},
		{
			label : '9 à 11 mois',
			moisAffichage: '11',
			moisMax : 12
		},
		{
			label : '12 mois',
			moisAffichage: '12',
			moisMax : 13
		},
		{
			label : '13 à 15 mois',
			moisAffichage: '15',
			moisMax : 16
		},
		{
			label : '16 à 18 mois',
			moisAffichage: '18',
			moisMax : 19
		},
		{
			label : '19 à 24 mois',
			moisAffichage: '23',
			moisMax : 24
		},
		{
			label : '2 ans',
			moisAffichage: '24',
			moisMax : 36
		},
		{
			label : '3 ans',
			moisAffichage: '36',
			moisMax : 48
		},
		{
			label : '4 ans',
			moisAffichage: '48',
			moisMax : 60
		},
		{
			label : '5 ans',
			moisAffichage: '60',
			moisMax : 72
		},
		{
			label : '6 et 7 ans',
			moisAffichage: '84',
			moisMax : 96
		},
		{
			label : '8 et 9 ans',
			moisAffichage: '108',
			moisMax : 120
		},
		{
			label : '10 à 13 ans',
			moisAffichage: '156',
			moisMax : 168
		}
	]
};
